document.addEventListener("DOMContentLoaded", () => {
  const mq = window.matchMedia("(min-width: 992px)");
  let isDesktop = mq.matches;
  let resizeTimeout;

  function handleViewportChange(e) {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const nowDesktop = e.matches;

      // Só recarrega se mudou de estado (mobile ↔ desktop)
      if (nowDesktop !== isDesktop) {
        location.reload();
      }

      isDesktop = nowDesktop;
    }, 300); // ⏱️ debounce de 300ms
  }

  if (typeof mq.addEventListener === "function") {
    mq.addEventListener("change", handleViewportChange);
  } else {
    mq.addListener(handleViewportChange); // Safari mais antigo
  }

  // Ancoragem com scroll suave (compensando a navbar fixa)
  const SCROLL_OFFSET = 148;

  function scrollToId(id) {
    const element = document.getElementById(id);
    if (!element) return;

    const top = element.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-scroll-to]");
    if (!trigger) return;

    event.preventDefault();
    scrollToId(trigger.dataset.scrollTo);
  });

  // Barra de navegação
  let lastScrollTop = 0;
  const navbar = document.querySelector(".navbar__header .bottom");


  if (navbar) {
    // Sem throttle, esse handler roda a cada evento nativo de scroll (dezenas
    // de vezes por segundo em touch scroll no mobile), lendo e escrevendo
    // estilo no mesmo tick — layout thrashing que trava a rolagem em Android
    // mais fraco. Agrupamos numa única atualização por frame via rAF.
    let navbarScrollRaf = null;

    const updateNavbarOnScroll = () => {
      navbarScrollRaf = null;
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > lastScrollTop && currentScroll > 82) {
        navbar.style.top = "-50%";
      } else {
        navbar.style.top = "100%";
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    };

    window.addEventListener(
      "scroll",
      function () {
        if (navbarScrollRaf) return;
        navbarScrollRaf = requestAnimationFrame(updateNavbarOnScroll);
      },
      { passive: true }
    );
  }

  const menuItems = document.querySelectorAll(".navbar__header .menu__item");

  menuItems.forEach((item) => {
    const dropdown = item.querySelector(".menu__sublinks");
    if (!dropdown) return;

    if (window.innerWidth > 992) {
      const positionDropdown = () => {
        // Reseta para posição padrão antes de medir novamente.
        dropdown.style.right = "auto";
        dropdown.style.left = "0";

        const rect = dropdown.getBoundingClientRect();

        if (rect.right > window.innerWidth) {
          dropdown.style.left = "auto";
          dropdown.style.right = "0";
        }
      };

      item.addEventListener("mouseenter", () => {
        item.classList.add("active");

        // Mede com o submenu ativo para evitar medidas incorretas em elementos ocultos.
        requestAnimationFrame(positionDropdown);
      });

      item.addEventListener("mouseleave", () => {
        item.classList.remove("active");
      });
    }

    if (window.innerWidth < 992) {
      item.addEventListener("click", (e) => {
        if (e.target.closest(".menu__sublinks a")) return;
        e.preventDefault();

        menuItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove("active");
          }
        });

        item.classList.toggle("active");
      });
    }
  });

  // Menu mobile
  const menu = document.querySelector(".navbar__header .menu-mobile");
  const wrapper = document.querySelector(".navbar__header .wrapper-mobile");
  const body = document.querySelector("body");
  const btnToggle = document.querySelector(
    ".navbar__header .navbar__mobile .mobile"
  );
  const btnClose = document.querySelector(".navbar__header .close-btn");
  const links = document.querySelectorAll(".navbar__header .menu-mobile a");

  // Abrir/fechar menu
  function toggleMenuMobile() {
    menu.classList.toggle("active");
    wrapper.classList.toggle("active");
    body.classList.toggle("active");
  }

  // Fechar menu
  function closeMenuMobile() {
    menu.classList.remove("active");
    wrapper.classList.remove("active");
    body.classList.remove("active");
  }

  // Abrir com botão de menu
  btnToggle?.addEventListener("click", function (event) {
    event.stopPropagation();
    toggleMenuMobile();
  });

  // Fechar com botão X
  btnClose?.addEventListener("click", function (event) {
    event.stopPropagation();
    closeMenuMobile();
  });

  // Fechar ao clicar fora do menu
  menu?.addEventListener("click", function (event) {
    if (!wrapper.contains(event.target)) {
      closeMenuMobile();
    }
  });

  // Fechar ao clicar em qualquer link
  links.forEach((link) => {
    link.addEventListener("click", () => {
      closeMenuMobile();
    });
  });

  // Variantes dos cards
  // const variantsCard = document.querySelectorAll(
  //   ".custom__product-card .swiper"
  // );

  // variantsCard.forEach((wrapper) => {
  //   new Swiper(wrapper, {
  //     slidesPerView: "auto",
  //     spaceBetween: 8,
  //     freeMode: true,
  //     grabCursor: true,
  //   });
  // });

  initUpsellCartPriceUpdates();

});

// #cart-upsell__wrapper é uma lista vertical simples (ver custom-cart.css),
// não um carrossel — não inicializar Swiper nela.

function initUpsellCartPriceUpdates() {
  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  };

  const items = document.querySelectorAll('.cart-upsell__item');
  items.forEach((item) => {
    const select = item.querySelector('.cart-upsell__variant-select');
    if (!select) return;

    if (select._upsellPriceHandler) {
      select.removeEventListener('change', select._upsellPriceHandler);
    }

    const handler = () => {
      const variantsScript = item.querySelector('[data-upsell-variants]');
      if (!variantsScript) return;

      let variants = [];
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

      const selectedVariant = variants.find((v) => String(v.id) === String(select.value));
      if (!selectedVariant) return;

      const currentEl = item.querySelector('[data-upsell-current]');
      const compareEl = item.querySelector('[data-upsell-compare]');

      if (currentEl) currentEl.textContent = formatMoney(selectedVariant.price);

      if (compareEl) {
        if (selectedVariant.compare_at_price > selectedVariant.price) {
          compareEl.textContent = formatMoney(selectedVariant.compare_at_price);
          compareEl.classList.remove('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('hidden');
        }
      }
    };

    select._upsellPriceHandler = handler;
    select.addEventListener('change', handler);
  });
}

(function () {
  "use strict";

  /**
   * Inicializa os Swipers de variantes dentro de um contexto
   * @param {HTMLElement|Document} context
   */
  function initVariantSwipers(context) {
    context = context || document;

    const swipers = context.querySelectorAll(
      ".custom__product-card .swiper:not(.swiper-initialized)"
    );

    if (!swipers.length) return;

    swipers.forEach((wrapper) => {
      new Swiper(wrapper, {
        slidesPerView: "auto",
        spaceBetween: 8,
        freeMode: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
      });
    });
  }

  /**
   * Inicializa a navbar fixa de ancoragem dentro de um contexto
   * @param {HTMLElement|Document} context
   */
  function initStickyAnchorNavbar(context) {
    context = context || document;

    const navbar = context.querySelector("#delucc-navbar");
    const sentinel = context.querySelector("#delucc-sentinel");
    if (!navbar || !sentinel) return;

    if (navbar.dataset.customStickyBound === "true") return;
    navbar.dataset.customStickyBound = "true";

    let triggerPoint = 0;
    let cachedHeaderBottom = 0;

    function measureHeaderBottom() {
      const baseHeight = window.innerWidth >= 992 ? 124 : 108;
      const marqueeEl = document.getElementById("customInfiniteMarquee");
      const marqueeH = marqueeEl ? marqueeEl.getBoundingClientRect().height : 0;
      return baseHeight + marqueeH;
    }

    function calculateTrigger() {
      cachedHeaderBottom = measureHeaderBottom();
      triggerPoint = sentinel.getBoundingClientRect().top + window.scrollY - cachedHeaderBottom;
    }

    function onScroll() {
      if (window.scrollY >= triggerPoint) {
        navbar.classList.add("is-fixed");
        navbar.style.top = cachedHeaderBottom + "px";
      } else {
        navbar.classList.remove("is-fixed");
        navbar.style.top = "";
      }
    }

    calculateTrigger();
    onScroll();

    window.addEventListener("load", () => {
      calculateTrigger();
      onScroll();
    });

    const headerGroup = document.getElementById("header-group");
    if (headerGroup) {
      new MutationObserver(() => {
        calculateTrigger();
        onScroll();
      }).observe(headerGroup, { childList: true, subtree: false });
    }

    // Mesmo motivo do listener da navbar principal: agrupar por frame via rAF
    // em vez de rodar onScroll a cada evento nativo de scroll.
    let stickyScrollRaf = null;
    window.addEventListener(
      "scroll",
      () => {
        if (stickyScrollRaf) return;
        stickyScrollRaf = requestAnimationFrame(() => {
          stickyScrollRaf = null;
          onScroll();
        });
      },
      { passive: true }
    );

    let resizeRaf = null;
    window.addEventListener("resize", () => {
      if (resizeRaf) return;
      resizeRaf = requestAnimationFrame(() => {
        resizeRaf = null;
        calculateTrigger();
        onScroll();
      });
    });
  }

  function initQuickbuyModal() {
    if (document.documentElement.dataset.customQuickbuyBound === "true") return;

    const modal = document.getElementById("custom-quickbuy-modal");
    if (!modal) return;

    const content = modal.querySelector("[data-quickbuy-modal-content]");
    const closeButton = modal.querySelector("[data-quickbuy-close]");

    if (!content) return;

    document.documentElement.dataset.customQuickbuyBound = "true";

    let swiperMain = null;
    let swiperThumbs = null;
    let activeQuickbuyProductId = null;
    let buyBoxAbortController = null;

    // Produtos "kit" usam o app block kit-selector (Mix and Match Kit), que
    // manipula globalmente o primeiro form[data-type="add-to-cart-form"] e
    // button[type="submit"][name="add"] do documento. Enquanto o quickbuy
    // estiver aberto, neutralizamos temporariamente esses elementos fora do
    // modal (ex.: o form da própria PDP, se o quickbuy for aberto a partir de
    // um card de "produtos relacionados" na página do produto) para garantir
    // que o kit-selector encontre apenas o form do modal.
    const neutralizedElements = [];

    const neutralizeOtherAddToCartForms = () => {
      document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
        if (modal.contains(form)) return;
        form.dataset.type = "add-to-cart-form-inactive";
        neutralizedElements.push({ el: form, attr: "data-type", value: "add-to-cart-form" });
      });

      document.querySelectorAll('button[type="submit"][name="add"]').forEach((button) => {
        if (modal.contains(button)) return;
        button.name = "add-inactive";
        neutralizedElements.push({ el: button, attr: "name", value: "add" });
      });
    };

    const restoreOtherAddToCartForms = () => {
      while (neutralizedElements.length) {
        const { el, attr, value } = neutralizedElements.pop();
        el.setAttribute(attr, value);
      }
    };

    // Scripts inseridos via innerHTML/DOMParser não executam automaticamente
    // (restrição do próprio browser). Precisamos recriar cada <script> pra
    // que o JS do app block (kit-selector.js) realmente rode.
    const executeScripts = (container) => {
      container.querySelectorAll("script").forEach((oldScript) => {
        const newScript = document.createElement("script");
        for (const { name, value } of oldScript.attributes) {
          newScript.setAttribute(name, value);
        }
        newScript.textContent = oldScript.textContent;

        // kit-selector.js (Mix and Match Kit) só se inicializa no evento
        // DOMContentLoaded da página — que já disparou muito antes de
        // injetarmos esse HTML no quickbuy, então o listener dele nunca mais
        // dispara sozinho. Como é um script clássico (sem type="module"),
        // sua função top-level `initKitSelector` fica exposta em
        // window.initKitSelector — chamamos manualmente assim que o script
        // (re)carregar, pra cada [data-kit-selector] que veio no fragmento.
        if (newScript.src && newScript.src.includes("kit-selector")) {
          newScript.addEventListener("load", () => {
            if (typeof window.initKitSelector !== "function") return;
            container.querySelectorAll("[data-kit-selector]").forEach((root) => {
              window.initKitSelector(root);
            });
          });
        }

        oldScript.replaceWith(newScript);
      });
    };

    // Busca a seção REAL da PDP (sections/product-information.liquid) via
    // Section Rendering API, e recorta do HTML retornado só o trecho entre o
    // bloco de preço e o de buy-buttons (que inclui o kit-selector no meio,
    // sem precisarmos saber como o markup dele é montado). Usar a seção real
    // — em vez de duplicar a configuração dos blocks numa seção própria —
    // garante que qualquer block adicionado/alterado na PDP (inclusive o
    // app block do Mix and Match Kit) apareça automaticamente aqui também.
    //
    // O id de seção qualificado (ex.: "template--28522876436845__main") não é
    // um valor fixo/previsível — depende do template registrado na loja e
    // pode ser diferente entre ambientes (dev/produção). Por isso, na
    // primeira vez buscamos a página completa do produto e descobrimos o id
    // real pelo prefixo estável "ProductInformation-", cacheando pra reusar
    // com fetches leves (?section_id=...) nas próximas aberturas do quickbuy.
    let cachedMainSectionId = null;

    const swapBuyBox = (quickbuyRoot, productUrl) => {
      if (!productUrl) return;

      buyBoxAbortController?.abort();
      buyBoxAbortController = new AbortController();
      const { signal } = buyBoxAbortController;

      const baseUrl = productUrl.split("?")[0];
      const requestUrl = cachedMainSectionId
        ? `${baseUrl}?section_id=${cachedMainSectionId}`
        : baseUrl;

      fetch(requestUrl, { signal })
        .then((response) => response.text())
        .then((responseText) => {
          if (signal.aborted) return;

          const parsed = new DOMParser().parseFromString(responseText, "text/html");
          const detailsRoot = parsed.querySelector('[id^="ProductInformation-"]');
          if (!detailsRoot) return;

          if (!cachedMainSectionId) {
            const match = detailsRoot.id.match(/^ProductInformation-(.+)$/);
            if (match) cachedMainSectionId = match[1];
          }

          // <product-price> é o custom element renderizado por blocks/price.liquid;
          // .buy-buttons-block é a classe fixa renderizada por blocks/buy-buttons.liquid.
          // Tudo entre esses dois pontos (inclusive) é price + kit-selector + variant-picker + buy-buttons.
          const startEl = detailsRoot.querySelector("product-price");
          const buyButtonsEls = detailsRoot.querySelectorAll(".buy-buttons-block");
          const endEl = buyButtonsEls[buyButtonsEls.length - 1];
          if (!startEl || !endEl) return;

          const range = parsed.createRange();
          range.setStartBefore(startEl);
          range.setEndAfter(endEl);
          const buyBoxFragment = range.cloneContents();

          const anchor = quickbuyRoot.querySelector("[data-quickbuy-buy-box-anchor]");
          if (!anchor || !anchor.parentNode) return;

          neutralizeOtherAddToCartForms();

          const wrapper = document.createElement("div");
          wrapper.className = "quickbuy-buy-box";
          wrapper.appendChild(buyBoxFragment);
          anchor.replaceWith(wrapper);

          executeScripts(wrapper);
        })
        .catch((error) => {
          if (error.name === "AbortError") return;
          console.error(error);
        });
    };

    const destroyGallery = () => {
      if (swiperMain && typeof swiperMain.destroy === "function") {
        swiperMain.destroy(true, true);
      }
      if (swiperThumbs && typeof swiperThumbs.destroy === "function") {
        swiperThumbs.destroy(true, true);
      }
      swiperMain = null;
      swiperThumbs = null;
    };

    const closeModal = () => {
      if (!modal.open) return;
      modal.close();
      destroyGallery();
      buyBoxAbortController?.abort();
      restoreOtherAddToCartForms();
      activeQuickbuyProductId = null;
      content.innerHTML = "";
    };

    const initGallery = (scope) => {
      const thumbsEl = scope.querySelector(".swipper-thumbs");
      const mainEl = scope.querySelector(".swipper-container");

      if (!mainEl || typeof Swiper === "undefined") return;

      if (thumbsEl) {
        swiperThumbs = new Swiper(thumbsEl, {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            992: { direction: "vertical" },
            0: { direction: "horizontal" },
          },
        });
      }

      swiperMain = new Swiper(mainEl, {
        spaceBetween: 10,
        navigation: {
          nextEl: mainEl.querySelector(".swiper-button-next"),
          prevEl: mainEl.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: mainEl.querySelector(".swiper-pagination"),
          type: "fraction",
        },
        thumbs: swiperThumbs ? { swiper: swiperThumbs } : undefined,
      });
    };

    const openFromCard = (card) => {
      const template = card.querySelector(".custom-quickbuy-template");
      if (!(template instanceof HTMLTemplateElement)) return;

      destroyGallery();
      content.innerHTML = "";

      const fragment = template.content.cloneNode(true);
      content.appendChild(fragment);

      const quickbuyRoot = content.querySelector(".custom-quickbuy-product");
      if (!quickbuyRoot) return;
      activeQuickbuyProductId = quickbuyRoot.dataset.productId || null;

      initGallery(quickbuyRoot);

      modal.showModal();

      const productUrl = card.dataset.productUrl || card.querySelector(".product__image-wrapper")?.getAttribute("href");
      swapBuyBox(quickbuyRoot, productUrl);
    };

    document.addEventListener("cart:update", () => {
      requestAnimationFrame(initUpsellCartPriceUpdates);
    });

    document.addEventListener("cart:update", (event) => {
      if (!modal.open || !activeQuickbuyProductId) return;

      const source = event?.detail?.data?.source;
      const productId = String(event?.detail?.data?.productId || "");

      if (source === "product-form-component" && productId === String(activeQuickbuyProductId)) {
        closeModal();
      }
    });

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-quickbuy-open]");

      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        const card = trigger.closest(".custom__product-card");
        if (card) {
          openFromCard(card);
        }

        return;
      }

      if (event.target.closest("[data-quickbuy-close]")) {
        closeModal();
      }
    });

    document.addEventListener("keydown", (event) => {
      const trigger = event.target.closest("[data-quickbuy-open]");
      if (!trigger) return;

      if (event.key !== "Enter" && event.key !== " ") return;

      event.preventDefault();

      const card = trigger.closest(".custom__product-card");
      if (card) {
        openFromCard(card);
      }
    });

    modal.addEventListener("click", (event) => {
      const rect = modal.getBoundingClientRect();
      const isInDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;

      if (!isInDialog) {
        closeModal();
      }
    });

    closeButton?.addEventListener("click", closeModal);
  }

  /**
   * Inicialização no carregamento inicial da página
   */
  function onDomReady() {
    initVariantSwipers(document);
    initQuickbuyModal();
    initStickyAnchorNavbar(document);
    if (typeof Fancybox !== "undefined") {
      Fancybox.bind("[data-fancybox]", {
        Carousel: {
          Thumbs: {
            type: "classic",
          },
          Toolbar: {
            display: {
              left: ["counter"],
              middle: ["zoomIn", "zoomOut", "reset"],
              right: ["close"],
            },
          }
        },
      });
    }
  }

  /**
   * Shopify Sections (renderizadas via AJAX)
   */
  function onShopifySectionLoad(event) {
    if (!event || !event.target) return;
    initVariantSwipers(event.target);
    initQuickbuyModal();
    initStickyAnchorNavbar(event.target);
  }

  // Parseia texto "R$ 249,99" → 249.99
  function parsePrice(text) {
    if (!text) return 0;
    const cleaned = (text || '').replace(/[^\d,]/g, '').replace(',', '.');
    return parseFloat(cleaned) || 0;
  }

  function getCurrentPrice() {
    const el = document.querySelector('.product-details product-price span.price');
    return el ? parsePrice(el.textContent.trim()) : 0;
  }

  // Mostra/oculta as opções "frete grátis" do widget de frete de acordo
  // com o preço atual do produto (o app de frete não sabe da nossa regra
  // de valor mínimo).
  function evaluateFreeShippingVisibility() {
    const price = getCurrentPrice();
    const shipPriceEls = document.querySelectorAll('span.ship-price');

    shipPriceEls.forEach((span) => {
      const text = span.textContent.trim().toLowerCase();
      if (!text.includes('grátis') && !text.includes('gratis')) return;

      // Sobe na árvore até encontrar a "linha" do resultado de frete
      const row = span.closest('tr, li, [class*="ship-option"], [class*="shipping-option"]')
        || span.parentElement?.parentElement
        || span.parentElement;

      if (!row) return;
      row.style.display = price < 250 ? 'none' : '';
    });
  }

  function initFreeShippingVisibility() {
    // Re-avaliar quando a variante mudar (DOM do preço já foi atualizado nesse ponto)
    document.addEventListener('variant:update', evaluateFreeShippingVisibility);

    // Avaliação inicial (caso a página já tenha resultados)
    evaluateFreeShippingVisibility();
  }

  /**
   * Observer único para o body: cobre tanto produtos carregados
   * dinamicamente (infinite scroll/AJAX) quanto os resultados do widget de
   * frete injetados por app externo.
   *
   * Antes havia DOIS MutationObserver separados, cada um com
   * childList+subtree sobre o document.body inteiro (o fallback pra
   * [data-product-grid]/#ProductGridContainer/.product-grid, que não
   * existem em nenhum template deste tema, então sempre caía no body).
   * Isso fazia com que QUALQUER mutação no DOM da página inteira — drawer
   * do carrinho, badges, swiper, apps de terceiros — disparasse os dois
   * callbacks, gerando jank perceptível em Android mais fraco.
   *
   * Aqui: um único observer, e o trabalho pesado (querySelectorAll/init)
   * é agrupado num único requestAnimationFrame por burst de mutações, em
   * vez de rodar a cada mutação individual.
   */
  function observeBodyMutations() {
    const productContainer =
      document.querySelector("[data-product-grid]") ||
      document.querySelector("#ProductGridContainer") ||
      document.querySelector(".product-grid");

    const target = productContainer || document.body;

    const pendingNodes = [];
    let rafId = null;

    const SHIP_SELECTOR = 'span.ship-price';

    const flush = () => {
      rafId = null;

      let hasShippingNodes = false;

      pendingNodes.forEach((node) => {
        // Se o próprio node for um card
        if (node.matches && node.matches(".custom__product-card")) {
          initVariantSwipers(node);
        } else if (node.querySelectorAll) {
          // Se o node contiver cards
          const cards = node.querySelectorAll(".custom__product-card");
          if (cards.length) {
            cards.forEach((card) => initVariantSwipers(card));
          }
        }

        // Reavaliar frete grátis é custoso (querySelectorAll + closest no
        // documento inteiro) e não precisa rodar em TODA mutação do body —
        // só quando o próprio widget de frete injeta/atualiza resultados.
        // Como o observer cobre o body inteiro (nenhum container mais
        // específico existe neste tema), qualquer app de terceiro chatty
        // (chat, reviews, drawer do carrinho) senão dispararia isso a cada
        // mutação, gerando trabalho constante em background no mobile.
        if (!hasShippingNodes) {
          if (node.matches && node.matches(SHIP_SELECTOR)) {
            hasShippingNodes = true;
          } else if (node.querySelector && node.querySelector(SHIP_SELECTOR)) {
            hasShippingNodes = true;
          }
        }
      });
      pendingNodes.length = 0;

      if (hasShippingNodes) {
        evaluateFreeShippingVisibility();
      }
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          pendingNodes.push(node);
        });
      });

      if (rafId === null) {
        rafId = requestAnimationFrame(flush);
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }

  /**
   * Bind de eventos globais
   */
  document.addEventListener("DOMContentLoaded", onDomReady);
  document.addEventListener("shopify:section:load", onShopifySectionLoad);

  /**
   * Start observer
   */
  observeBodyMutations();
  initFreeShippingVisibility();
})();